import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=1d08c94c&scoped=true&lang=html&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d08c94c",
  null
  
)

export default component.exports